import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {BookingComponent} from "./booking.component";
import {BookingRoutingModule} from "./booking-routing.module";
import {BookingFilterComponent} from "./filter/booking-filter.component";
import {BookingListComponent} from "./list/booking-list.component";
import {SharedModule} from "../../shared/shared.module";
import {BookingDetailComponent} from "./detail/booking-detail.component";
import {EmailTooltipComponent} from "./email-tooltip.component";
import {NewFeatureTooltipComponent} from "./new-feature-tooltip.component";
import {HomeModule} from "../home/home.module";

@NgModule({
    imports: [CommonModule, FormsModule, BookingRoutingModule, TranslateModule, SharedModule, HomeModule],
    declarations: [
        BookingComponent,
        BookingListComponent,
        BookingFilterComponent,
        BookingDetailComponent,
        NewFeatureTooltipComponent,
        EmailTooltipComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class BookingModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/booking/booking.module.ts